<span [ngStyle]="{ 'width': size + 'px', 'height': size + 'px', 'border-radius': circle ? size/2 + 'px' : 0 + 'px' }"
     [ngClass]=" enabled? 'user-pic-enabled' : 'user-pic-disabled' ">
     <img *ngIf="imagePath" alt="User Image" [src]="imagePath | imagePath" [width]="size" [height]="size">
     <span *ngIf="!imagePath"
          [ngStyle]="{ 'font-size': size*0.45 + 'px', 'line-height': size*0.75 + 'px', 'padding': size/8 + 'px', 'width': size + 'px' }">
          {{initials}}
     </span>
</span>
